const ROLE_LEVELS = {
    user: 1,
    admin: 2,
    owner: 3,
} as const

export const canAssignRole = (inviterRole: string, targetRole: string): boolean => {
    const inviterLevel = ROLE_LEVELS[inviterRole as keyof typeof ROLE_LEVELS]
    const targetLevel = ROLE_LEVELS[targetRole as keyof typeof ROLE_LEVELS]

    if (!inviterLevel || !targetLevel) {
        return false
    }

    return inviterLevel >= targetLevel
}
